import script from "./Co2QuestionsSortingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuestionsSortingForm.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuestionsSortingForm.vue?vue&type=style&index=0&id=5c9131f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c9131f0"]])

export default __exports__